import { render, staticRenderFns } from "./callsummary.vue?vue&type=template&id=2625576a&scoped=true&"
import script from "./callsummary.vue?vue&type=script&lang=ts&"
export * from "./callsummary.vue?vue&type=script&lang=ts&"
import style0 from "./callsummary.vue?vue&type=style&index=0&id=2625576a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2625576a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VList,VListItem,VListItemContent,VRow})
